import React, { useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import * as styles from '@/components/form/form.module.scss'
import FormContext from '@/components/form/form-context'
import TextElement from '@/components/text-element/text-element'
import { formMessages } from '@/constants/form-messages'
import { type IFormGate } from '@/internal/types/form'

import Checkbox from '../fields/checkbox'

const StepSelectContents: React.FC = () => {
  const {
    getValues,
    formState: { errors },
    setValue
  } = useFormContext()
  const values = getValues() as IFormGate
  const { contentSelected } = useContext(FormContext)
  const labels = formMessages[values.form]
  const { downloads } = values

  useEffect(() => {
    if (contentSelected && contentSelected.length > 0) {
      const contentSelectedObject = contentSelected.map((contentId) => [
        `contentSelected-${contentId}`,
        true
      ])

      contentSelectedObject.forEach(([key, value]) => {
        setValue(key as string, value)
      })
    } else {
      downloads?.forEach((item) => {
        setValue(`contentSelected-${item.originalId}`, true)
      })
    }
  }, [contentSelected, setValue])

  return (
    <>
      <TextElement type="h2" text={labels.stepSelectContentsTitle} />
      <TextElement type="h3" text={labels.stepSelectContentsDescription} />

      {values.form === 'paperDetail' && (
        <>
          <div className={styles.checkbokItembox}>
            <p className={styles.currentPaper}>{downloads?.[0].externalName}</p>
          </div>
          <TextElement
            className={styles.selectOthers}
            type="p"
            text={formMessages.gate.stepSelectContentsViewOtherPapers}
          />
        </>
      )}

      <div className={styles.assetsBox}>
        {Array.isArray(downloads) &&
          downloads.length > 0 &&
          // If the form is in a paper detail, we remove the first element from the array
          (values.form === 'paperDetail' ? downloads.slice(1) : downloads).map(
            (content, index) => {
              const id = `contentSelected-${content.originalId}`
              const keyFormatted = (index + 1).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
              })
              return (
                <div key={id} className={styles.checkbokItembox}>
                  <Checkbox
                    key={id}
                    id={id}
                    label={`${keyFormatted}. ${content.externalName}`}
                  />
                </div>
              )
            }
          )}
        {errors['']?.type === 'any.custom' && (
          <span>{formMessages.errors.minimumOneOption}</span>
        )}
      </div>
    </>
  )
}

export default StepSelectContents
